<script>
  import GameOverButton from "./GameOverButton.svelte"
</script>

<div class="flex items-center justify-center h-full bg-gray-600 text-white">
  <div class="mr-2"><GameOverButton /></div>
  <div class="text-2xl font-roboto_bold mx-3">Game Over</div>
</div>
